<template>
  <transition name="nudge-fade">
    <div v-if="visible" class="nudge-overlay" @click.self="close">
      <div class="nudge-box" role="alert" aria-live="assertive">
        <div class="nudge-icon">&#9888;</div>
        <p class="nudge-text">{{ message }}</p>
        <button class="nudge-close" @click="close" aria-label="Close">OK</button>
      </div>
    </div>
  </transition>
</template>

<script>
import { nudgeBus } from '../utils/nudgeBus'

export default {
  name: 'NudgeMessage',
  data() {
    return {
      visible: false,
      message: '',
      _timer: null
    }
  },
  created() {
    nudgeBus.$on('show-nudge', ({ message, duration }) => {
      this.message = message
      this.visible = true
      if (this._timer) clearTimeout(this._timer)
      if (duration && duration > 0) {
        this._timer = setTimeout(() => this.close(), duration * 1000)
      }
    })
  },
  beforeDestroy() {
    nudgeBus.$off('show-nudge')
    if (this._timer) clearTimeout(this._timer)
  },
  methods: {
    close() {
      this.visible = false
      this.message = ''
      if (this._timer) { clearTimeout(this._timer); this._timer = null }
    }
  }
}
</script>

<style scoped>
.nudge-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

.nudge-box {
  background: #fff;
  border-top: 6px solid #d32f2f;
  border-radius: 6px;
  padding: 32px 40px;
  max-width: 480px;
  width: 90%;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25);
}

.nudge-icon {
  font-size: 40px;
  color: #d32f2f;
  margin-bottom: 12px;
}

.nudge-text {
  font-size: 16px;
  color: #333;
  margin-bottom: 24px;
  line-height: 1.5;
}

.nudge-close {
  background: #d32f2f;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 36px;
  font-size: 15px;
  cursor: pointer;
  font-weight: 600;
}

.nudge-close:hover {
  background: #b71c1c;
}

.nudge-fade-enter-active,
.nudge-fade-leave-active {
  transition: opacity 0.2s ease;
}

.nudge-fade-enter,
.nudge-fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/NudgeMessage.vue?ffccbf32